import { AppBar, styled } from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';
import { HEADER_HEIGHT, HIDDEN_SIDEBAR_WIDTH, SIDEBAR_WIDTH } from '../../constants/layout';
import { ROUTE_LABELS } from '../../constants/routes';

const TopAppBar = styled(AppBar, {
  shouldForwardProp: prop => prop !== 'sidebarOpen',
})(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '3px',
  justifyContent: 'space-between',
  flexDirection: 'row',
  backgroundColor: 'white',
  padding: '15px 30px',
  boxShadow: '0 23px 44px 0 #B0B7C30E',
  height: HEADER_HEIGHT,
  marginLeft: HIDDEN_SIDEBAR_WIDTH,
  width: `calc(100% - ${HIDDEN_SIDEBAR_WIDTH}px)`,
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ sidebarOpen }) => sidebarOpen,
      style: {
        marginLeft: SIDEBAR_WIDTH,
        width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const TopBar = ({ sidebarOpen }) => {
  const { userProfile } = useSelector(state => state.me);
  const location = useLocation();
  // Function to determine the appropriate breadcrumb links
  const getBreadcrumbLinks = () => {
    // ROUTE_LABELS is keyed by route *pattern*, so an exact lookup misses every
    // parameterized route ('/custom-dashboards/10' vs the registered
    // '/custom-dashboards/:dashboardId') and the header rendered blank. Fall
    // back to pattern matching before giving up.
    const label =
      ROUTE_LABELS[location.pathname] ??
      Object.entries(ROUTE_LABELS).find(([pattern]) => matchPath(pattern, location.pathname))?.[1] ??
      '';
    return <span className='text-[#020202] font-semibold'>{label}</span>;
  };

  return (
    <TopAppBar position='relative' sidebarOpen={sidebarOpen} sx={{ displayPrint: 'none' }}>
      <div className='flex items-center font-semibold text-2xl'>{getBreadcrumbLinks()}</div>
      <div className='flex items-center font-semibold text-2xl'>
        <div className='pr-1'>
          <h5 className='text-[#161616] font-[Manrope] font-semibold text-sm'>
            {`${userProfile.firstName} ${userProfile.lastName}`}
          </h5>
        </div>
      </div>
    </TopAppBar>
  );
};

TopBar.propTypes = {
  sidebarOpen: PropTypes.bool,
  handleSidebarToggle: PropTypes.func,
};

export default TopBar;
